module.exports = __webpack_public_path__ + "img/reference21.e62b71ad.jpg";